import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';
import toDangerousReactHtml from '../../helper/to_dangerous_react_html';

function CrossSellRemoveLightBoxContent(props) {
    const {
        data,
        onRemove,
        onAccept,
        onClose
    } = props;
    const isTyreSizeProtect = (data && data.productType === "tyre_size_protect");

    return (
      <div className="cross-sell-remove-light-box__content cross-sell-remove-light-box-content">
        <p className="cross-sell-remove-light-box-content__why-alignment">
          <Translation
            tagName="b"
            translationKey={
              isTyreSizeProtect
                ? 'cross-sell-remove-light-box-why-alignment-tyre-size-prefix'
                : 'cross-sell-remove-light-box-why-alignment-prefix'
            }
          />{' '}
          <Translation
            translationKey={
              isTyreSizeProtect
                ? 'cross-sell-remove-light-box-why-alignment-tyre-size'
                : 'cross-sell-remove-light-box-why-alignment'
            }
          />{' '}
        </p>

        <div className="cross-sell-remove-light-box-content__actions">
          <Translation
            tagName="button"
            className="cross-sell-remove-light-box-content__action-accept"
            onClick={onAccept}
            translationKey="cross-sell-remove-light-box-header-action-accept"
          />

          <Translation
            tagName="button"
            className="cross-sell-remove-light-box-content__action-remove"
            onClick={() => {
              onRemove(data);
            }}
            translationKey="cross-sell-remove-light-box-header-action-remove"
          />
        </div>

        {props.error && props.error.invalid && (
          <p
            name="error-remove-fs"
            className="cross-sell-remove-light-box-content__why-alignment floating-label-element__hint--invalid"
            style={{ border: 'none' }}
            dangerouslySetInnerHTML={toDangerousReactHtml(props.error.invalidMessage)}
          />
        )}
      </div>
    );
}

CrossSellRemoveLightBoxContent.propTypes = {
    expanded: PropTypes.bool.isRequired,
    error: PropTypes.object,
    onExpand: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onAccept: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { CrossSellRemoveLightBoxContent };
